export default __webpack_public_path__ + "images/pazze-logo-black.png";